type PasswordResetListener = () => void;

let listeners: PasswordResetListener[] = [];
let alreadyNotified = false;

export function onPasswordResetRequired(listener: PasswordResetListener): () => void {
  listeners.push(listener);

  return () => {
    listeners = listeners.filter((item) => item !== listener);
  };
}

export function notifyPasswordResetRequired(): void {
  if (alreadyNotified) {
    return;
  }

  alreadyNotified = true;
  listeners.forEach((listener) => listener());
}

export function resetPasswordResetNotification(): void {
  alreadyNotified = false;
}
